export default (snakeCaseString) => (
  snakeCaseString.replace(/([-_][a-z])/g, (group) => (
    group.toUpperCase().replace('-', '').replace('_', '')
  ))
);
